import { useEffect } from 'react'
import appConfig from 'shared-module/config/appConfig'
import switches from 'shared-module/config/switches'
import TagManager from 'react-gtm-module'
import GA4Analytics from 'shared-module/analytics/GA4Analytics'

const MarketingCampaign = () => {
  useEffect(() => {
    const initializeAnalytics = () => {
      // Initialize GTM (existing implementation)
      if (appConfig.gtm?.switch === switches.on && appConfig.gtm?.id) {
        const tagManagerArgs = {
          gtmId: appConfig.gtm.id,
          auth: appConfig.gtm.auth,
          preview: appConfig.gtm.preview,
          dataLayerName: 'purchasedProduct',
        }
        TagManager.initialize(tagManagerArgs)
      }

      // Initialize GA4 (new implementation)
      if (appConfig.ga4?.switch === switches.on && appConfig.ga4?.measurementId) {
        GA4Analytics.initialize()
      }
    }

    initializeAnalytics()
  }, [])

  return null
}

export default MarketingCampaign
